
import * as d3 from 'd3'

export default {
  methods: {

    draw_Forms() {

      this.canvasForms = this.svg
      .append('g')
      .attr('id', `CANVAS_FROM`)
      .attr('transform', `translate(20.5, 20.5)`)
      .attr('cursor', 'default')
      .attr('font-family', 'roboto')

      this.canvasForms
      .append('text')
      .attr('transform', `translate(0, 0)`).attr('font-size', 9).attr('fill', '#757575')
      .text('Sub-System No.')

      this.canvasForms
      .append('text')
      .attr('transform', `translate(0, 15)`).attr('font-size', 14).attr('fill', '#000')
      .text(this.rawData.SUBSYS)

      this.canvasForms
      .append('text')
      .attr('transform', `translate(150, 0)`).attr('font-size', 9).attr('fill', '#757575')
      .text('Area')

      this.canvasForms
      .append('text')
      .attr('transform', `translate(150, 15)`).attr('font-size', 13).attr('fill', '#757575')
      .text(this.rawData.AREA)

      this.canvasForms
      .append('text')
      .attr('transform', `translate(0, 40)`).attr('font-size', 9).attr('fill', '#757575')
      .text('Sub-System Description')

      this.canvasForms
      .append('text')
      .attr('transform', `translate(0, 55)`).attr('font-size', 13).attr('fill', '#757575')
      .text(this.rawData.SUBSYS_DESC)


      

      this.draw_ITRs(this.mc, 20)
      
      this.draw_MCC(326)
      this.draw_ITRs(this.sc, 490)

      if (this.sundries) {
        let sunData = this.JQueries.sundriesConfig && this.JQueries.sundriesConfig.SQL ? this.Queries[this.JQueries.sundriesConfig.SQL][0] : this.DataItems[0]
        if(this.sundries.length > 0) this.gmx_Sundries(this.svg, this.sundries, sunData, this.JQueries.sundriesConfig.server)
      }

    },
  }
}